import type { JSX, ReactNode } from 'react'
import styled from 'styled-components'

import { Tone, TONES } from '../colors'

const StyledBadge = styled.span<{ $tone: Tone }>`
  display: inline-flex;
  flex: none;
  align-items: center;
  gap: 6px;
  height: 20px;
  padding: 0 8px;
  border-radius: 10px;
  background: ${({ $tone }) => TONES[$tone].bg};
  color: ${({ $tone }) => TONES[$tone].fg};
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  white-space: nowrap;
`

export const StatusDot = styled.span<{ $tone: Tone }>`
  display: inline-block;
  flex: none;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ $tone }) => TONES[$tone].dot};
`

type StatusBadgeProps = {
  tone: Tone
  children: ReactNode
  withDot?: boolean
}

export function StatusBadge({ tone, children, withDot = false }: StatusBadgeProps): JSX.Element {
  return (
    <StyledBadge $tone={tone}>
      {withDot && <StatusDot $tone={tone} aria-hidden="true" />}
      {children}
    </StyledBadge>
  )
}
